
import $ from "jquery"

import StickyNavbarHandler from "app/sticky_navbar_handler/index"
import Notifier from "app/notifier/index"
import ServicedApartmentsConcierge from "concepts/cities/concierge/serviced_apartments"

interface Selector {
  scope:                  string | JQuery
  concierge_section:      string
  btn_concierge_scroll:   string
  map_section:            string
  map_link_button:        string
}
interface InputSelector {
  scope?:                 string | JQuery
  concierge_section?:     string
  btn_concierge_scroll?:  string
  map_section?:           string
  map_link_button?:       string
}
const DEFAULT_SELECTOR = {
  scope:                  "html",
  concierge_section:      ".page-section--concierge",
  btn_concierge_scroll:   ".btn-concierge-scroll",
  map_section:            ".page--cities--serviced-apartment-buildings--map",
  map_link_button:        ".page--cities--serviced-apartment-buildings--map-link-button",
}


class ServicedApartmentsSidebar {
  protected selector: Selector
  protected $scope: JQuery

  protected $concierge_section: JQuery
  protected $btn_concierge_scroll: JQuery

  protected $map_section: JQuery
  protected $map_link_button: JQuery

  constructor(selector?: InputSelector){
    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    this.$scope = $(this.selector.scope)

    this.$concierge_section = this.$scope.find(this.selector.concierge_section)
    this.$btn_concierge_scroll = this.$scope.find(this.selector.btn_concierge_scroll)

    this.$map_section = this.$scope.find(this.selector.map_section)
    this.$map_link_button = this.$scope.find(this.selector.map_link_button)

    ServicedApartmentsConcierge.init()

    this.bind_action()
  }

  protected reset_to_concierge_box(){
    StickyNavbarHandler.scrollTo(this.$concierge_section, {
      duration: 0,
    })
    Notifier.closeAll()
  }

  protected reset_to_map_box(){
    StickyNavbarHandler.scrollTo(this.$map_section, {
      duration: 0,
    })
  }
  protected bind_action(){
    this.$btn_concierge_scroll.on("click", (e) => {
      e.preventDefault()
      this.reset_to_concierge_box()
    })

    this.$map_link_button.on("click", (e) => {
      e.preventDefault()

      this.reset_to_map_box()
    })
  }
}

const Factory = {
  create(){
    return new ServicedApartmentsSidebar()
  },
}

export {
  Factory,
}
